// Payment
export { PaymentIFrameComponent } from './payment/payment-iframe.component';

// Coverages
export { CoverageDisplayListComponent } from './coverages/coverage-display-list.component';
export { CoverageDisplayComponent } from './coverages/coverage-display.component';
export { CoverageDrawerComponent } from './coverages/coverage-drawer.component';

// Receipt
export { ReceiptComponent } from './receipt/receipt.component';

// Alert Box
export { AlertBoxComponent } from './alert-boxes/alert-box.component';

// sidebar
export { AgentQuoteSidebarComponent } from './agent-quote-sidebar/agent-quote-sidebar.component';

// Agents
export { CreditAgentPanelComponent } from './agents/credit-agent-panel.component';
export { TypeaheadAgentNameSearchComponent } from './agents/typeahead-agent-name-search.component';
export { TypeaheadAgentCodeSearchComponent } from './agents/typeahead-agent-code-search.component';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/index.ts